"use client";

import { useEffect } from "react";

import { logErrorToCloudWatch } from "@/shared/lib/aws/cloudwatch";

export default function Error({ error, reset }: { error: { digest?: string } & Error; reset: () => void }) {
    useEffect(() => {
        // Log the error to CloudWatch
        logErrorToCloudWatch(error, undefined, {
            digest: error.digest,
            type: "next_error_boundary",
        });
    }, [error]);

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-4">
            <h2 className="text-xl font-bold mb-2">Something went wrong</h2>
            <p className="text-gray-600 mb-4">We&apos;ve been notified and are working to fix the issue.</p>
            <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600" onClick={() => reset()}>
                Try again
            </button>
        </div>
    );
}
